import { type ListingPrice } from '@/generated'
import { formatPrice } from '@/utils/kijiji-common/money'

/**
 * Returns the original price if it exists, otherwise returns the current price
 * When the originalPrice exists, it means that the price has been dropped
 *
 * @param price
 * @returns string - Returns the original price if it exists, otherwise returns the current price that was dropped
 */
export const formatOriginalPrice = (
  price: ListingPrice,
  config?: { isFrench?: boolean; suppressCents?: boolean }
): string => {
  return price.originalPrice?.amount
    ? formatPrice(price?.originalPrice.amount, config) || ''
    : formatPrice(price.amount, config) || ''
}

/**
 * Returns the price drop if it exists, otherwise returns an empty string
 *
 * @param price
 * @returns string
 */
export const formatPriceDrop = (
  price: ListingPrice,
  config?: { isFrench?: boolean; suppressCents?: boolean }
): string => {
  return !price.originalPrice?.amount ? '' : formatPrice(price.amount, config) || ''
}
